import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import NavbarSelector from "../NavbarSelector";
import ModalRoutes from "./ModalRoutes";

import axios from "axios";
import { LoadingIcon } from '../Common/Loading_Icon';
import UserInfo from './ProfileSettings/UserInfo';
import Verification from './ProfileSettings/Verification';
import Security from './ProfileSettings/Security';
import Notifications from './ProfileSettings/Notifications';
import { constants } from '../../Helpers/Constants';
import { Trans } from 'react-i18next';

class Settings extends Component {
  constructor(props) {
    super(props);

    this.changeTab = this.changeTab.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.userInfoRef = React.createRef();
    this.verificationRef = React.createRef();
    this.securityRef = React.createRef();
    this.notificationsRef = React.createRef();
    this.state = {
      tab: "user_info",
      width: 0,
      height: 0,
    };
  }

  //add listener for scroll - use some derivative of changeTab() to reflect scrolling on sidebar

  componentDidMount() {
    document.title = "Profile Settings - FleetXPress";
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    if (
      this.props.match.params.tab !== "" &&
      (this.props.match.params.tab === "user_info" ||
        this.props.match.params.tab === "verification" ||
        this.props.match.params.tab === "security" ||
        this.props.match.params.tab === "notifications")
    ) {
      //wait 2s for page to load before attempting to scroll to the position specified in the URL
      setTimeout(
        function() {
          this.changeTab(this.props.match.params.tab);
        }.bind(this),
        2000
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    window.removeEventListener("scroll", this.updateSidebar);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  changeTab(tab) {
    this.props.history.push("/settings/" + tab);
    this.setState({
      tab,
    });

    switch (tab) {
      case "user_info": {
        window.scrollTo({
          top: this.userInfoRef.current.offsetTop - 70,
          left: 0,
          behavior: "smooth",
        });
        return;
      }
      case "verification": {
        window.scrollTo({
          top: this.verificationRef.current.offsetTop - 70,
          left: 0,
          behavior: "smooth",
        });
        return;
      }
      case "security": {
        window.scrollTo({
          top: this.securityRef.current.offsetTop - 70,
          left: 0,
          behavior: "smooth",
        });
        return;
      }
      case "notifications": {
        window.scrollTo({
          top: this.notificationsRef.current.offsetTop - 70,
          left: 0,
          behavior: "smooth",
        });
        return;
      }
    }
  }

  renderTab() {
    if (this.state.tab === "user_info") {
      return <UserInfo />;
    } else if (this.state.tab === "verification") {
      return <Verification />;
    } else if (this.state.tab === "security") {
      return <Security />;
    } else if (this.state.tab === "notifications") {
      return <Notifications />;
    }
  }

  renderTabs() {
    if (this.state.width < 768) {
      return (
        <div className="settings_page mobile_settings_page">
          <div className="sectioned" ref={this.userInfoRef}>
            <UserInfo />
          </div>
          <div className="sectioned" ref={this.verificationRef}>
            <h1 style={{ paddingLeft: 30, marginTop: 30 }}><Trans>Verification</Trans></h1>
            <Verification />
          </div>
          <div className="sectioned" ref={this.securityRef}>
            <h1 style={{ paddingLeft: 30, marginTop: 30 }}><Trans>Security</Trans></h1>
            <Security />
          </div>
          <div className="sectioned" ref={this.notificationsRef}>
            <h1 style={{ paddingLeft: 30, marginTop: 30 }}><Trans>Notifications</Trans></h1>
            <Notifications />
            <li
              style={{
                justifyContent: "flex-end",
                display: "flex",
                marginRight: "10%",
                marginBottom: "5%",
              }}
            >
              <a
                href="#user_info"
                onClick={(e) => {
                  e.preventDefault();
                  this.changeTab("user_info");
                }}
              >
                <img
                  //className="survey-success-icon"
                  src="/images/icons/icon-back-to-top.svg"
                />
              </a>
            </li>
          </div>
        </div>
      );
    } else {
      return (
        <div className="settings_page desktop_settings_page">
          <div className="sectioned" ref={this.userInfoRef}>
            <UserInfo />
          </div>
          <div className="sectioned" ref={this.verificationRef}>
            <h1 style={{ paddingLeft: 30, marginTop: 30 }}><Trans>Verification</Trans></h1>
            <Verification />
          </div>
          <div className="sectioned" ref={this.securityRef}>
            <h1 style={{ paddingLeft: 30, marginTop: 30 }}><Trans>Security</Trans></h1>
            <Security />
          </div>
          <div className="sectioned" ref={this.notificationsRef}>
            <h1 style={{ paddingLeft: 30, marginTop: 30 }}><Trans>Notifications</Trans></h1>
            <Notifications />
            <li
              style={{
                justifyContent: "flex-end",
                display: "flex",
                marginRight: "10%",
                marginBottom: "5%",
              }}
            >
              <a
                href="#user_info"
                onClick={(e) => {
                  e.preventDefault();
                  this.changeTab("user_info");
                }}
              >
                <img
                  //className="survey-success-icon"
                  src="/images/icons/icon-back-to-top.svg"
                />
              </a>
            </li>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div className={"bkg-white-dark pb-24"}>
        <NavbarSelector
          history={this.props.history}
          match={this.props.match}
          location={this.props.location}
        />
        <div className="settings fixed-navbar-page">
          {this.state.width > 768 ? (
            <div className="settings_sidebar">
              <span className="settings_sidebar_header"><Trans>User Profile</Trans></span>
              <div className="settings_sidebar_options">
                <div
                  onClick={() => this.changeTab("user_info")}
                  className={
                    "settings_sidebar_option" +
                    (this.state.tab === "user_info" ? " settings_sidebar_active" : "")
                  }
                >
                  <Trans>User Info</Trans>
                </div>
                <div
                  onClick={() => this.changeTab("verification")}
                  className={
                    "settings_sidebar_option" +
                    (this.state.tab === "verification" ? " settings_sidebar_active" : "")
                  }
                >
                  <Trans>Verification</Trans>
                </div>
                <div
                  onClick={() => this.changeTab("security")}
                  className={
                    "settings_sidebar_option" +
                    (this.state.tab === "security" ? " settings_sidebar_active" : "")
                  }
                >
                  <Trans>Security</Trans>
                </div>
                <div
                  onClick={() => this.changeTab("notifications")}
                  className={
                    "settings_sidebar_option" +
                    (this.state.tab === "notifications" ? " settings_sidebar_active" : "")
                  }
                >
                  <Trans>Notifications</Trans>
                </div>
              </div>
            </div>
          ) : null}
          {this.renderTabs()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  userSession: store.userSession,
});

export default connect(mapStateToProps)(Settings);
